<template>
    <div class="short-video-list">

        <short-video-list-skeleton v-if="loading" style="margin-bottom: 100vh"></short-video-list-skeleton>

        <div class="tags">
            <van-tabs :swipeable="true" v-model="category_index" @click="changeCategory">
                <van-tab :title-class="'short-video-list-category-title'" v-for="(item,index) in categories" :disabled="item.id > 998" :key="index" :title="item.name" ></van-tab>
            </van-tabs>
            <div class="clear"></div>
        </div>

        <van-row class="short-video-list-section">
            <div class="short-video-list-box" v-for="(item,index) in list" :key="item.id" @click="$router.push({name:'short-video-detail',params:{id:item.id}})">
                <div class="short-video-list-box-img">
                    <van-image
                        fit="cover"
                        :src="item.cover_img"
                        style="width: 100%;height: 100%;border-radius: 6px;"
                    />
                    <div class="short-video-list-box-play-count">
                        <img src="/static/img/icon_live_watch.svg" alt="">
                        {{item.view_count}}
                    </div>
                </div>
                <div class="short-video-list-box-title">{{item.title}}</div>
            </div>
            <van-empty description="已到底部" v-if="list.length == 0" />
        </van-row>
    </div>
</template>
<script>
    import Interface from "@/util/interface"
    import shortVideoListSkeleton from "@/skeleton/shortVideoListSkeleton"
    export default {
        name: 'short-video-list',
        components :{
            'short-video-list-skeleton' : shortVideoListSkeleton
        },
        data() {
            return {
                value: "",
                active: "",
                category_id: 0,
                category_child_id: 0,
                banners: [],
                categories: [],
                categories_child: [],
                recommend: [],
                list:[],
                loading:true,
                category_index:0
            }
        },
        methods: {
            fetch(scene) {
                if (scene === 'banner') {
                    Interface.getData('get', Interface.banner, {type: 1}).then((res) => {
                        this.banners = res.data
                    })
                } else if (scene === 'category') {
                    Interface.getData('get', Interface.short_video.category).then((res) => {
                        this.categories = res.data
                        this.categories.unshift({name: "推荐", id: 0})
                        if (this.categories.length < 5) {
                            for (let i = 999; i <= (1007 - this.categories.length); i++) {
                                this.categories.push({name: "", id: i})
                            }
                        }
                        this.changeCategory()
                    })
                } else if (scene === 'short-video') {
                    let params = {
                        category_id: this.category_id,
                        pageSize:999
                    }
                    Interface.getData('get', Interface.short_video.list,params).then((res) => {
                        this.list = res.data.list
                        setTimeout(()=>{
                            this.loading = false
                        },500)
                    })
                }
            },
            changeCategory() {
                this.category_id = this.categories[this.category_index].id
                this.fetch('short-video')
            }
        },
        created() {
            this.fetch('banner')
            this.fetch('category')
            this.fetch('short-video')
            Interface.getShareInfo(this,"行业热门短视频——博医同行","","")
        },
    }
</script>
<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/short-video/list/index.vue